import { topicTags } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-8">
          热门话题
        </h2>
        <div className="flex flex-wrap justify-center gap-3">
          {topicTags.map((tag, i) => (
            <div
              key={i}
              className="group flex items-center gap-2 px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer"
            >
              {tag.hot && (
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-fire-line text-primary-500 text-sm"></i>
                </span>
              )}
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                {tag.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">
                {tag.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}